var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3333 0H5.83329C7.67421 0 9.16659 1.49237 9.16659 3.3333V5.83329C9.16659 7.67421 7.67421 9.16659 5.83329 9.16659H3.3333C1.49237 9.16663 0 7.67425 0 5.83329V3.3333C0 1.49237 1.49237 0 3.3333 0Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 0H16.666C18.5069 0 19.9993 1.49237 19.9993 3.3333V5.83329C19.9993 7.67421 18.5069 9.16659 16.666 9.16659H14.166C12.3251 9.16659 10.8327 7.67421 10.8327 5.83329V3.3333C10.8327 1.49237 12.3251 0 14.166 0Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 10.832H5.83332C7.67424 10.832 9.16662 12.3244 9.16662 14.1653V16.6653C9.16662 18.5062 7.67424 19.9986 5.83332 19.9986H3.33333C1.49241 19.9987 3.05176e-05 18.5063 3.05176e-05 16.6654V14.1654C3.05176e-05 12.3244 1.49241 10.832 3.33333 10.832Z",
    fill: "#525252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 10.832H16.666C18.5069 10.832 19.9993 12.3244 19.9993 14.1653V16.6653C19.9993 18.5063 18.5069 19.9987 16.666 19.9987H14.166C12.3251 19.9987 10.8327 18.5063 10.8327 16.6654V14.1654C10.8327 12.3244 12.3251 10.832 14.166 10.832Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.c3258313f77a5b1c1a890c6b3aa3c6c5.svg";
export { ForwardRef as ReactComponent };